import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import get from 'lodash/get';

import SimpleBarChart from '../../../../components/SimpleBarChart';
import withHostContext from '../../../../context/host/consumer';

const messages = defineMessages({
  thisCollege: {
    id: 'hubs.costs.tuition-and-fees.this-college',
    defaultMessage: 'This College',
  },
  avgCollegesInNaviance: {
    id: 'hubs.costs.tuition-and-fees.avg-colleges-in-naviance',
    defaultMessage: 'Average of Colleges in Naviance*',
  },
  avgCollegesInState: {
    id: 'hubs.costs.tuition-and-fees.avg-colleges-in-state',
    defaultMessage: 'Average of Colleges in {state}*',
  },
  avgCollegesNationally: {
    id: 'hubs.costs.tuition-and-fees.avg-colleges-nationally',
    defaultMessage: 'Average of Colleges in U.S.*',
  },
});

class TuitionAndFeesChart extends React.PureComponent {
  static propTypes = {
    tuitionAndFees: PropTypes.number,
    outOfStateTuitionAndFees: PropTypes.number,
    avgTuitionAndFees: PropTypes.number,
    avgOutOfStateTuitionAndFees: PropTypes.number,
    collegeState: PropTypes.string,
    isNational: PropTypes.bool,
    intl: PropTypes.object,
    hostContext: PropTypes.object,
  };

  render() {
    const {
      tuitionAndFees,
      outOfStateTuitionAndFees,
      avgTuitionAndFees,
      avgOutOfStateTuitionAndFees,
      isNational,
      intl,
      hostContext,
    } = this.props;

    if (
      !tuitionAndFees &&
      !outOfStateTuitionAndFees &&
      !avgTuitionAndFees &&
      !avgOutOfStateTuitionAndFees
    ) {
      return null;
    }

    const isCamino = get(hostContext, 'isCamino', false);

    let compareMessageOne;
    let compareMessageTwo;

    if (isCamino) {
      compareMessageOne = intl.formatMessage(messages.avgCollegesNationally);
      compareMessageTwo = intl.formatMessage(messages.avgCollegesNationally);
    } else {
      compareMessageOne = intl.formatMessage(messages.avgCollegesInNaviance);
      compareMessageTwo = intl.formatMessage(messages.avgCollegesInNaviance);
    }

    const chartData = [
      {
        value: tuitionAndFees,
        displayValue: `$${tuitionAndFees.toLocaleString('en-US')}`,
        label: intl.formatMessage(messages.thisCollege),
        color: isCamino ? '#33367A' : '#8bc100',
      },
      {
        value: avgTuitionAndFees,
        displayValue: `$${avgTuitionAndFees.toLocaleString('en-US')}`,
        label: compareMessageOne,
        color: isCamino ? 'rgba(51, 54, 122, 0.25)' : '#a0a1ba',
      },
    ];

    if (!isNational) {
      chartData[1].isGap = true;
      chartData.push({
        value: outOfStateTuitionAndFees,
        displayValue: `$${outOfStateTuitionAndFees.toLocaleString('en-US')}`,
        label: intl.formatMessage(messages.thisCollege),
        color: '#009cd5',
      });
      chartData.push({
        value: avgOutOfStateTuitionAndFees,
        displayValue: `$${avgOutOfStateTuitionAndFees.toLocaleString('en-US')}`,
        label: compareMessageTwo,
        color: '#a0a1ba',
      });
    }

    const titles = isNational ? [] : ['IN-STATE', 'OUT-OF-STATE'];

    return (
      <SimpleBarChart
        chartData={chartData}
        titles={titles}
        displayValueColor={isCamino ? '#000' : null}
      />
    );
  }
}

export default injectIntl(withHostContext(TuitionAndFeesChart));
